import React, { useMemo } from "react";
import { Constant } from "../../../Common";
import { Space, Radio } from "antd";
import { _Filter_Types, _Filters_Handlers, FilterActions } from "../";
import { has } from "lodash";
const {
	Tenant: { EBM_REGIONAL }
} = Constant;
const Filters = {
	[EBM_REGIONAL]: {
		_Label: "",
		_ApiTag: "shop_data.EBM_REGIONAL_dms_matched",
		_Type: _Filter_Types.Radio,
		_Childrens: [
			{
				_Label: "Include",
				_ApiTag: "YES"
			},
			{
				_Label: "Exclude",
				_ApiTag: "Not_Available"
			},
			{
				_Label: "Ignore",
				_ApiTag: "Ignore"
			}
		]
	}
};
function TopLevelFilter({ value, _tenant, dispatch, _SectionApiTag = FilterActions.TOP_LEVEL_FILTER }) {
	const { _ApiTag, _Label, _Childrens } = useMemo(() => {
		if (has(Filters, _tenant)) {
			dispatch({
				type: FilterActions.addSection,
				value: { newSection: { [FilterActions.TOP_LEVEL_FILTER]: { [FilterActions.FilterType]: true } } }
			});

			return Filters[_tenant];
		} else {
			return { _ApiTag: null, _Label: null, _Children: null };
		}
	}, [_tenant, dispatch]);
	if (!has(Filters, _tenant)) return <></>;
	return (
		<div>
			<div className="d-flex flex-row justify-content-lg-between ">
				<div className="mr-2 tanet-name">{_Label}</div>
				<div className="mt-1">
					<Radio.Group
						onChange={e =>
							_Filters_Handlers[_Filter_Types.Radio]({
								dispatch,
								_SectionApiTag,
								_ApiTag: _ApiTag,
								_Child_ApiTag: e.target.value,
								_tenant
							})
						}
						value={value[_ApiTag] || ""}
					>
						<Space direction="horizontal" size="small" style={{ display: "flex" }} align="left">
							{_Childrens.map(({ _ApiTag: _Child_ApiTag, _Label: _Child_Label }) => {
								return <Radio value={_Child_ApiTag}>{_Child_Label}</Radio>;
							})}
						</Space>
					</Radio.Group>
				</div>
			</div>
		</div>
	);
}

export default React.memo(TopLevelFilter);
